const environment = process.env.NODE_ENV
const project = 'Verification'
const server = null
const service = null
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  //redirect to Azure page
  routes: {
    label: 'Verification',
    prefix: '/verification',
  },
}

export default config
